export const accessData = [
  {
    index: 0,
    name: "Acceso 3: VIP y Hospitality",
    coords: [
      [25.682067, -100.286545]
    ],
    color: '#F9C42F',
    type: 'Accesos',
  },
  {
    index: 2,
    name: "Acceso 5: Fundidora",
    coords: [
      [25.682497, -100.281781]
    ],
    color: '#FA04B0',
    type: 'Accesos',
  },
  {
    index: 3,
    name: "Acceso 6: Fundidora",
    coords: [
      [25.680940, -100.277699]
    ],
    color: '#FA04B0',
    type: 'Accesos',
  },
  {
    index: 4,
    name: "Acceso CINTERMEX",
    coords: [
      [25.678889, -100.286328]
    ],
    color: '#FA04B0',
    type: 'Accesos',
  },
  {
    index: 5,
    name: "Acceso 7: Fundidora",
    coords: [
      [25.678242, -100.282897]
    ],
    color: '#FA04B0',
    type: 'Accesos',
  },
]
